import { getFullUrlPure } from 'hubspot-url-utils/pure';
import * as ClassicHublets from 'hubspot-url-utils/hublets';
import * as Hublets from 'hubspot-url-utils/hublets-next';
export const DPR_PREVIEW_CONFIG_UPDATE = 'DPR_PREVIEW_CONFIG_UPDATE';
export const DPR_PREVIEW_READY = 'DPR_PREVIEW_READY';
const curriedGetOrigin = subdomain => env => hublet => getFullUrlPure(subdomain, hublet, env);
const getApp = curriedGetOrigin('app');

// The exact set of HubSpot app origins the settings host can embed us from
// (mirrors magpie-lib's safe-origins: classic hublets for QA, next hublets for
// prod). Used to validate incoming message origins and to target the readiness
// ping — never a substring/regex check.
export const getAllowedParentOrigins = () => {
  const classicHublets = Object.values(ClassicHublets);
  const hublets = Object.values(Hublets);
  const getLocal = curriedGetOrigin('local');
  return [...classicHublets.map(getLocal('qa')), ...classicHublets.map(getApp('qa')), ...hublets.map(getLocal('prod')), ...hublets.map(getApp('prod'))];
};
const isRecord = value => typeof value === 'object' && value !== null;
const isOptionalString = value => value === undefined || typeof value === 'string';

// Validate an untrusted config payload from the settings host before it reaches
// preview state. Returns a typed partial to merge, or null if any known field
// is the wrong shape — guards the public iframe against a malformed payload
// from the embedding frame (the origin is already checked by the caller).
export const parsePreviewConfig = config => {
  if (!isRecord(config)) {
    return null;
  }
  const {
    branding,
    requestTypes,
    email,
    showCountrySetting,
    recaptchaEnabled
  } = config;
  if (branding !== undefined && (!isRecord(branding) || !isOptionalString(branding.companyName) || !isOptionalString(branding.logoAltText) || !isOptionalString(branding.logoUrl))) {
    return null;
  }
  if (requestTypes !== undefined && (!isRecord(requestTypes) || typeof requestTypes.DELETE_REQUEST !== 'boolean' || typeof requestTypes.EXPORT_REQUEST !== 'boolean')) {
    return null;
  }
  if (email !== undefined && typeof email !== 'string') {
    return null;
  }
  // showCountrySetting is a Chirp-generated union; validate as a string to stay
  // decoupled from codegen, matching how it travels on the wire.
  if (showCountrySetting !== undefined && typeof showCountrySetting !== 'string') {
    return null;
  }
  if (recaptchaEnabled !== undefined && typeof recaptchaEnabled !== 'boolean') {
    return null;
  }
  return config;
};